<div class="video-upload-dialog">
  <div class="header">
    <div class="title">
      {{ video.id ? 'Erklärvideo bearbeiten' : 'Neues Video hinzufügen' }}
    </div>
    <div class="close">
      <span class="fa fa-times" (click)="cancel()"></span>
    </div>
  </div>
  <div class="body">
    <div class="left">
      <div class="options-container">
        <div class="option-label">
          {{ 'module.videoUploadDialog.optionLabel' | translate }}
        </div>
        <div class="options">
          <div class="option-box" (click)="video.isExternal = false" [class.active-option]="!!!video.isExternal">
            <img alt="thumbnail-img" *ngIf="!video.isExternal" class="upload_icon1" src="assets/icons/ico_upload.svg" />
            <img alt="thumbnail-img" *ngIf="video.isExternal" class="upload_icon1" [src]="uploadSelect" />
            <label for="button" class="label-button-text">Video hochladen</label>
          </div>
          <span class="option-label">{{ 'module.videoUploadDialog.optionLabel2' | translate }}</span>
          <div class="option-box" (click)="video.isExternal = true" [class.active-option]="video.isExternal">
            <img alt="thumbnail-img" *ngIf="!video.isExternal" class="upload_icon1" [src]="link" />
            <img alt="thumbnail-img" *ngIf="video.isExternal" class="upload_icon1" [src]="linkSelect" />
            <label for="button" class="label-button-text">Video verlinken</label>
          </div>
        </div>
      </div>
      <div class="file-upload-container" *ngIf="!!!video.isExternal">
        <div class="label-text-12">
          {{ 'module.videoUploadDialog.videoLabelText' | translate }}
        </div>
        <div
          class="file-upload-box"
          ng2FileDrop
          [class.invalid-upload]="isVideoUploadError"
          *ngIf="video.videoBlob === null || video.videoBlob === undefined"
          [uploader]="videoUploader"
          (click)="videoCtrl.click()"
        >
          <input title="video-file" type="file" ng2FileSelect name="video" #videoCtrl accept="video/*" [uploader]="videoUploader" class="file-input" />
          <img alt="thumbnail-img" class="upload_icon" src="assets/icons/file-vid.svg" *ngIf="!isVideoUploadError" />
          <img alt="thumbnail-img" class="upload_icon" src="assets/icons/ico_video_red.png" *ngIf="isVideoUploadError" />
          <label
            for="video"
            class="label-text-12"
            [class.invalid-upload]="isVideoUploadError"
            [innerHTML]="isVideoUploadError ? videoErrorMessage : ('module.videoUploadDialog.videoBodyText' | translate)"
          >
          </label>
        </div>
        <div *ngIf="video.videoBlob" class="video-preview-container">
          <div class="video-details">
            <span class="label-text-12 video-name" [attr.title]="video.videoFileName">{{ video.videoFileName }}</span>
            <span class="fa fa-times-circle label-text-12" aria-hidden="true" (click)="removeFile()"></span>
          </div>
          <video controls class="video-player" #videoPlayer>
            <source [attr.src]="video.videoBlob" [attr.type]="video.modifiedMimeType" />
            {{ 'module.videoUploadDialog.browserDoesNotSupportText' | translate }}
          </video>
        </div>
      </div>
      <div class="input-with-label" *ngIf="!!video.isExternal">
        <span class="label-text-12">{{ 'module.videoUploadDialog.linkText' | translate }}</span>
        <mat-form-field class="text-input">
          <input title="external-link" matInput [(ngModel)]="video.externalLink" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="thumbnail-container">
        <div
          class="thumbnail-upload-box"
          ng2FileDrop
          [class.invalid-upload]="isThumbnailUploadError"
          [uploader]="thumbnailUploader"
          *ngIf="video.thumbnailBlob === null || video.thumbnailBlob === undefined"
          (click)="thumbnailCtrl.click()"
        >
          <input
            title="thumbnail-file"
            type="file"
            ng2FileSelect
            name="thumbnail"
            #thumbnailCtrl
            accept="image/*"
            [uploader]="thumbnailUploader"
            class="file-input"
          />
          <img alt="thumbnail-img" class="upload_icon" src="assets/icons/ico_thumbnail.svg" *ngIf="!isThumbnailUploadError" />
          <img alt="thumbnail-img" class="upload_icon" src="assets/icons/ico_thumbnail_red.png" *ngIf="isThumbnailUploadError" />
          <label
            for="thumbnail"
            class="label-text-12"
            [class.invalid-upload]="isThumbnailUploadError"
            [innerHTML]="isThumbnailUploadError ? thumbnailErrorMessage : ('module.videoUploadDialog.thumbnailBodyText' | translate)"
          >
          </label>
        </div>
        <div *ngIf="video.thumbnailBlob" class="thumbnail-preview">
          <img alt="thumbnail-img" [attr.src]="video.thumbnailBlob | async" class="thumbnail-image" />
        </div>
        <div class="thumbnail-labels">
          <div class="thumbnail-label-action">
            <span class="label-text-12" [attr.title]="video.thumbnailFileName">{{ video.thumbnailFileName }}</span>
            <span class="fa fa-times-circle label-text-12" aria-hidden="true" (click)="removeThumbnail()" *ngIf="video.thumbnailBlob"></span>
          </div>
          <button class="btn btn-outline-primary thumbnail-button" (click)="thumbnailCtrl?.nativeElement.click()">Vorschaubild hochladen</button>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="input-with-label">
        <span class="label-text-12">{{ 'module.videoUploadDialog.titleText' | translate }}</span>
        <mat-form-field class="text-input">
          <input title="video-title" matInput [(ngModel)]="video.title" autocomplete="off" maxLength="50" />
        </mat-form-field>
      </div>
      <span class="label-text-12">{{ 'module.videoUploadDialog.labelText' | translate }}</span>
      <div class="editor">
        <p-editor
          [(ngModel)]="video.description"
          #editor
          (onTextChange)="editorTextChanged($event)"
          placeholder="Hier neuen Text eingeben (Max. 2.000 Zeichen)"
        >
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-link" aria-label="Link"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>
  </div>
</div>
<div class="footer">
  <button class="btn btn-outline-primary footer-btn" (click)="cancel()">
    {{ 'module.videoUploadDialog.buttonText1' | translate }}
  </button>
  <button class="btn btn-outline-primary footer-btn" (click)="save()" [disabled]="!isValid()">
    {{ 'module.videoUploadDialog.buttonText2' | translate }}
  </button>
</div>
